import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ca35341ce95d76db28918ab4547b90e2.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto w-full">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            幹細胞×自動化で<br />再生医療の未来をつくる
          </h1>
          <p className="text-lg md:text-xl mb-8 opacity-95">
            Exosome Oneは、細胞培養ロボットと先端バイオ技術で、美容・医療業界の革新を支援します。
          </p>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="aspect-video rounded-xl overflow-hidden shadow-2xl">
            <iframe 
              src="https://player.vimeo.com/video/1069424491?h=4728105eba&background=1" 
              className="w-full h-full"
              frameBorder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            完全自動培養ロボットの開発について
          </h2>
          
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-start gap-6 mb-8">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                <i className="ri-microscope-line text-3xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">
                  細胞培養の自動化と再生医療の実装で、医療の未来を支える。
                </h3>
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Advanced%20automated%20stem%20cell%20cultivation%20laboratory%20with%20sophisticated%20bioreactors%20and%20intelligent%20monitoring%20systems%2C%20professional%20scientists%20in%20white%20coats%20working%20with%20automated%20cell%20culture%20equipment%2C%20sterile%20environment%20with%20blue%20LED%20lighting%20and%20temperature%20controlled%20incubators%2C%20robotic%20arms%20performing%20precise%20cell%20culture%20operations%2C%20multiple%20culture%20flasks%20containing%20growing%20stem%20cells%2C%20modern%20biotechnology%20facility%20with%20HEPA%20filtration%20and%20CO2%20control%20systems%2C%20clean%20room%20environment%20showcasing%20the%20future%20of%20regenerative%20medicine%20automation&width=800&height=256&seq=automated-cell-culture-future-2024&orientation=landscape"
                    alt="細胞培養"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
                <p className="text-gray-700 mb-6">
                  Exosome Oneは、<strong>再生医療の普及と品質向上</strong>を目指し、以下の事業を展開しています。
                </p>
                
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm">1</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-2 text-gray-800">細胞培養ロボットの開発</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        自社開発による完全自動培養ロボットで、幹細胞大量培養を安定・効率化。再生医療現場の省人化・品質均一化を支援しています。
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm">2</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-2 text-gray-800">細胞由来原料の製造・提供</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        幹細胞培養上清液(エクソソーム（エキソソーム）)など、再生医療・美容領域で活用される原料を研究・製造・販売しています。
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm">3</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-2 text-gray-800">再生医療事業支援・技術指導</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        医療機関・研究機関向けに、施設構築・運用・人材育成・技術指導まで一貫してサポート。再生医療の社会実装を支えるトータルパートナーです。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-800">
            自動細胞培養のステップと、Exosome Oneの技術
          </h2>
          <p className="text-center text-gray-600 mb-12">
            当社は、完全自動培養ロボットの開発を行っています。
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-6 shadow-lg">
              <div className="mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Advanced%20automated%20cell%20seeding%20laboratory%20with%20robotic%20dispensing%20systems%20precisely%20placing%20stem%20cells%20into%20culture%20flasks%2C%20sterile%20environment%20with%20professional%20scientists%20operating%20high-tech%20cell%20seeding%20equipment%2C%20modern%20biotechnology%20facility%20with%20automated%20pipetting%20robots%20and%20cell%20counting%20devices%2C%20clean%20white%20laboratory%20setting%20with%20blue%20LED%20lighting%20and%20sophisticated%20incubators%20for%20optimal%20cell%20seeding%20density&width=400&height=192&seq=cell-seeding-automation-2024&orientation=landscape"
                  alt="細胞播種"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-10 h-10 bg-teal-600 text-white rounded-full font-bold">1</span>
                <h3 className="text-xl font-bold text-gray-800">細胞播種(シーディング)</h3>
              </div>
              <p className="text-gray-700 text-sm mb-2">
                自動分注機により、細胞を適切な密度で培養フラスコへ播種
              </p>
              <p className="text-gray-600 text-sm">
                均一な播種が、安定した細胞品質と再現性の高い培養を可能にします。
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-6 shadow-lg">
              <div className="mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20advanced%20stem%20cell%20cultivation%20laboratory%20with%20sophisticated%20bioreactors%20and%20automated%20cell%20culture%20systems%2C%20scientists%20in%20white%20coats%20monitoring%20cell%20growth%20in%20sterile%20incubators%2C%20CO2%20controlled%20environment%20with%20temperature%20and%20humidity%20monitoring%20systems%2C%20modern%20biotechnology%20facility%20with%20blue%20LED%20lighting%2C%20automated%20robotic%20arms%20performing%20precise%20cell%20culture%20operations%2C%20multiple%20culture%20flasks%20and%20petri%20dishes%20containing%20growing%20stem%20cells%2C%20clean%20room%20environment%20with%20HEPA%20filtration%20systems&width=400&height=192&seq=advanced-stem-cell-cultivation-lab-2024&orientation=landscape"
                  alt="細胞培養"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-10 h-10 bg-teal-600 text-white rounded-full font-bold">2</span>
                <h3 className="text-xl font-bold text-gray-800">細胞培養</h3>
              </div>
              <p className="text-gray-700 text-sm mb-2">
                CO2インキュベーター内で温度・湿度・ガス濃度を厳密に制御
              </p>
              <p className="text-gray-600 text-sm">
                Exosome Oneの自動ロボットが培地交換や移送も行い、完全自動化により人的ミスを排除します。
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-6 shadow-lg">
              <div className="mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Advanced%20cell%20observation%20and%20quality%20control%20laboratory%20with%20AI-powered%20microscopy%20cameras%20and%20sensors%20monitoring%20stem%20cell%20conditions%2C%20scientists%20analyzing%20cell%20morphology%20and%20growth%20patterns%20on%20computer%20screens%2C%20automated%20cell%20counting%20and%20viability%20assessment%20systems%2C%20modern%20biotechnology%20facility%20with%20microscopes%20and%20digital%20imaging%20equipment%2C%20real-time%20cell%20health%20monitoring%20and%20quality%20inspection%20processes&width=400&height=192&seq=cell-observation-inspection-2024&orientation=landscape"
                  alt="観察と検査"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-10 h-10 bg-teal-600 text-white rounded-full font-bold">3</span>
                <h3 className="text-xl font-bold text-gray-800">観察と検査</h3>
              </div>
              <p className="text-gray-700 text-sm mb-2">
                AI搭載カメラやセンサーで細胞の状態を定期的にモニタリング
              </p>
              <p className="text-gray-600 text-sm">
                必要に応じて培地交換・異常検知・収量の最適化行い、高品質な細胞製品の安定供給を実現しています。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Research Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Advanced%20stem%20cell%20research%20laboratory%20with%20scientists%20conducting%20cutting-edge%20experiments%20on%20regenerative%20medicine%2C%20modern%20biotechnology%20facility%20with%20sophisticated%20microscopes%20and%20cell%20culture%20equipment%2C%20researchers%20analyzing%20stem%20cell%20samples%20and%20developing%20new%20therapeutic%20treatments%2C%20clean%20white%20laboratory%20environment%20with%20state-of-the-art%20scientific%20instruments%20and%20incubators%2C%20stem%20cell%20colonies%20visible%20under%20microscopy%20on%20computer%20screens&width=600&height=384&seq=stem-cell-research-lab-2024&orientation=landscape"
                alt="幹細胞研究"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
                幹細胞とエクソソーム（エキソソーム）の研究で、次世代医療の選択肢を広げる
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                当社は、<strong>幹細胞培養上清液(エクソソーム（エキソソーム）)の機能解明と応用開発</strong>に注力しています。
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                国内外の研究機関・医療機関と連携し、安全性・有効性のエビデンスに基づいた臨床応用を推進。
              </p>
              <p className="text-gray-700 leading-relaxed">
                また、新しい治療法の創出や、がん・神経・美容領域への展開も視野に入れ、<strong>再生医療の可能性をより多くの人へ届けることを目指しています</strong>。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Exosome OneのVisionとMission
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-600 to-teal-700 text-white rounded-2xl p-8 shadow-xl">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Futuristic%20global%20healthcare%20vision%20with%20advanced%20stem%20cell%20research%20facilities%20worldwide%2C%20international%20regenerative%20medicine%20network%20connecting%20hospitals%20and%20research%20centers%2C%20scientists%20collaborating%20across%20continents%20through%20digital%20technology%2C%20modern%20medical%20cities%20with%20cutting-edge%20biotechnology%20buildings%2C%20world%20map%20showing%20connected%20medical%20facilities%2C%20bright%20hopeful%20lighting%20representing%20the%20future%20of%20medicine%20and%20healthy%20living%20for%20all%20humanity&width=800&height=256&seq=global-healthcare-vision-2024&orientation=landscape"
                  alt="Vision"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                Exosome Oneは、幹細胞由来エクソソーム技術を通じて、
                世界中の人々の健康と美しさに貢献し、
                再生医療・美容医療分野のグローバルリーダーとなることを目指します。
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-2xl p-8 shadow-xl">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20team%20of%20scientists%20and%20medical%20professionals%20working%20together%20in%20advanced%20biotechnology%20laboratory%2C%20diverse%20group%20of%20researchers%20collaborating%20on%20stem%20cell%20technology%20development%2C%20modern%20clean%20laboratory%20environment%20with%20cell%20culture%20equipment%2C%20scientists%20training%20and%20sharing%20knowledge%2C%20sustainable%20medical%20innovation%20with%20eco-friendly%20laboratory%20practices%2C%20teamwork%20and%20dedication%20in%20regenerative%20medicine%20research%20and%20development&width=800&height=256&seq=medical-team-mission-2024&orientation=landscape"
                  alt="Mission"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                Exosome Oneは、最先端のバイオテクノロジーと厳格な品質管理により、
                安全で効果的なエクソソーム製品を提供し、
                医療機関・化粧品メーカーのパートナーとして、
                持続可能な事業成長を支援します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Business Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            事業内容
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20regenerative%20medicine%20business%20consulting%20meeting%20with%20medical%20experts%2C%20doctors%20and%20business%20professionals%20discussing%20stem%20cell%20therapy%20clinic%20setup%2C%20modern%20conference%20room%20with%20medical%20charts%20and%20documents%2C%20healthcare%20business%20planning%20and%20regulatory%20compliance%20support%20for%20medical%20facilities&width=400&height=192&seq=regenerative-medicine-support-1&orientation=landscape"
                alt="再生医療事業への支援"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">再生医療事業への支援</h3>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>クリニックや研究機関の立ち上げ支援から、運用・人材育成・認可取得までをトータルサポート</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>再生医療等製品の製造に関わる専門技術やラボ導入支援も対応</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>中国・UAEを中心に、海外提携による技術連携・国際研究プロジェクトにも参画</span>
                  </li>
                </ul>
                <Link 
                  to="/business/support" 
                  className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-text-line"></i>
                  詳しく読む
                </Link>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Advanced%20stem%20cell%20research%20and%20development%20laboratory%20with%20scientists%20conducting%20experiments%2C%20modern%20biotechnology%20research%20facility%20with%20microscopes%20and%20cell%20culture%20equipment%2C%20researchers%20analyzing%20data%20and%20developing%20new%20therapies%2C%20clean%20white%20laboratory%20environment%20with%20cutting-edge%20scientific%20instruments%20and%20testing%20apparatus&width=400&height=192&seq=research-development-1&orientation=landscape"
                alt="研究・開発"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">研究・開発</h3>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>幹細胞培養の標準化を目指し独自プロトコールと培養プロセスを確立</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>細胞培養に用いる専用試験・機器の開発や、安全性評価の実証実験を推進</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>無血清培地や3D培養など、次世代技術への応用研究に取り組む</span>
                  </li>
                </ul>
                <Link 
                  to="/business/r-d" 
                  className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-text-line"></i>
                  詳しく読む
                </Link>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Advanced%20cosmetic%20ingredient%20development%20laboratory%20with%20stem%20cell%20derived%20materials%2C%20modern%20biotechnology%20facility%20for%20skincare%20formulation%2C%20scientists%20working%20with%20exosomes%20and%20growth%20factors%20for%20beauty%20products%2C%20clean%20white%20laboratory%20environment%20with%20sophisticated%20equipment%2C%20test%20tubes%20and%20petri%20dishes%20containing%20cosmetic%20ingredients&width=400&height=192&seq=cosmetic-ingredient-lab-1&orientation=landscape"
                alt="化粧品原料の開発・製造・販売"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">化粧品原料の開発・製造・販売</h3>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>幹細胞由来のエクソソーム（エキソソーム）を原料として、化粧品OEM・ODMに対応</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>GMPレベルの品質管理体制により、安全性と有効性の担保を実現</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>各メーカーの製品企画・処方箋開発ニーズに合わせた柔軟な共同開発が可能</span>
                  </li>
                </ul>
                <Link 
                  to="/business/ingredients" 
                  className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-text-line"></i>
                  詳しく読む
                </Link>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Advanced%20cell%20cultivation%20laboratory%20with%20modern%20bioreactors%20and%20automated%20cell%20culture%20systems%2C%20sterile%20environment%20with%20blue%20LED%20lighting%2C%20professional%20scientists%20working%20with%20stem%20cells%20in%20clean%20room%20facility%2C%20high-tech%20incubators%20and%20microscopes%2C%20futuristic%20biotechnology%20setting&width=400&height=192&seq=cell-cultivation-lab-1&orientation=landscape"
                alt="細胞の培養"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-gray-800">細胞の培養</h3>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>細胞加工認可を取得した自社施設で、幹細胞の大量培養を委託</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>安全自動化ロボットと独自プロトコールにより、品質の均一化と省人化を実現</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>医療機関向けに、細胞技術者の育成支援や指導プログラムも提供</span>
                  </li>
                </ul>
                <Link 
                  to="/business/bringup" 
                  className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-text-line"></i>
                  詳しく読む
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* エクソソームセクション */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-800">
                エクソソーム（エキソソーム）の力で美しさを革新
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                幹細胞から分泌されるエクソソーム（エキソソーム）は、細胞間コミュニケーションの重要な役割を担っています。
                私たちは最先端の技術でエクソソーム（エキソソーム）を抽出・精製し、化粧品や医療分野への応用を進めています。
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  細胞再生促進効果
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  アンチエイジング効果
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  治療効果の向上
                </li>
              </ul>
              <Link 
                to="/exosome" 
                className="bg-purple-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                詳しく見る
              </Link>
            </div>
            <div className="relative">
              <div className="w-full h-96 overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Advanced%20exosome%20research%20laboratory%20with%20scientists%20analyzing%20extracellular%20vesicles%20using%20high-tech%20microscopy%20equipment%2C%20exosome%20isolation%20centrifuge%20machines%2C%20cell%20culture%20incubators%2C%20and%20nanotechnology%20instruments%20in%20a%20clean%20modern%20biotech%20facility%20with%20blue%20LED%20lighting%20and%20sterile%20white%20environment%2C%20showing%20exosome%20particles%20under%20electron%20microscopy%20on%20computer%20screens&width=600&height=400&seq=exosome-lab-research-2024&orientation=landscape"
                  alt="エクソソーム（エキソソーム）研究・開発"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full opacity-20"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full opacity-15"></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-blue-600 text-white relative overflow-hidden">
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'url(https://storage.googleapis.com/studio-design-asset-files/projects/d7Wl265eqV/s-1920x1080_v-fms_webp_c56d575c-8715-4ef7-959d-5940e1887015.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Exosome Oneへのご相談・ご依頼はこちらから
          </h2>
          <p className="text-lg mb-8 opacity-95">
            再生医療事業の立ち上げ、細胞培養の委託、OEM・共同研究に関する相談など、<br />
            お気軽にお問い合わせください。専門スタッフが迅速に対応いたします。
          </p>
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-2xl"></i>
            お問い合わせ
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
